<template>
  <land-suitability-report />
</template>

<script>
import LandSuitabilityReport from "./Report.vue";

export default {
  name: "LandSuitabilityCreate",
  components: {
    LandSuitabilityReport,
  },
};
</script>
